import React, { Component } from 'react';
import { Icon as _Icon } from 'tmt-ui-kit';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  ${props => props.extraPad && 'padding-bottom: 16px;'}
  border-radius: 4px;
`;

const TitleContainer = styled.div`
  padding: 16px 25px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  > *:first-child {
    flex: 1;
  }
  
  ${props => props.isChangeBg && `background: ${props.theme.blueGrayLighter};`}

  @media(max-width: 600px) {
    padding: 16px;    
  }
`;

const BodyContainer = styled.div`
  /* border-radius: 6px; */
  /* background-color: ${props => props.theme.blueGrayTwo}; */
  /* border-left: 5px solid ${props => props.theme.orange}; */
  ${props => props.isChangeBg && `background: ${props.theme.blueGrayLighter};`}
  border-top: 1px solid ${props => props.theme.blueGray};
  padding: 16px 25px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  p {
    font-size: 16px !important;
  }
`;

const Icon = styled(_Icon)`
  color: ${props => props.theme.orange} !important;
`;

export default class Collapse extends Component {
  static propTypes = {
    renderTitle: PropTypes.func,
    renderBody: PropTypes.func,
    isChangeBg: PropTypes.bool,
  };

  state = {
    isShow: false
  };

  render() {
    const { renderTitle, renderBody, isChangeBg } = this.props;
    const { isShow } = this.state;
    return (
      <Container extraPad={isShow}>
        <TitleContainer isChangeBg={isChangeBg} onClick={() => this.setState({ isShow: !isShow})}>
          {renderTitle()}
          <Icon name={`chevron-${isShow ? 'up' : 'down'}`} />
        </TitleContainer>
        {isShow && (
          <BodyContainer isChangeBg={isChangeBg}>
            {renderBody()}
          </BodyContainer>
        )}
      </Container>
    );
  }
}
